import axios from 'axios'
import { API_BASE, apiErrorHandler, ApiFilter } from '../api'
import Auth from '../auth'

const EMAIL_ENDPOINT = `${API_BASE}emails/`

export default class EmailAPI {
  constructor(cls) {
    this.cls = cls
  }
  static create(cls) {
    return new EmailAPI(cls)
  }
  async getEmail(requestId, emailType, userId, organizationId) {
    const url = `${EMAIL_ENDPOINT}?requestId=${requestId}&emailType=${emailType}&organizationId=${organizationId}&userId=${userId}`
    const options = {
      headers: {
        ...Auth.getHeaders(),
      },
    }

    try {
      const response = await axios.get(url, options)
      return response.data
    } catch (err) {
      apiErrorHandler({ apiName: 'EmailApi.getEmail', enable400Alert: false })
      return
    }
  }
}
